export default function () {
    var body = document.getElementsByTagName('BODY')[0];
    var toggleLanguage = document.getElementById('toggleLanguage');
    var backdrop = document.getElementById('backdrop');
    var isTouchScreen = false;

    // Check device
    (function () {
        if ('ontouchstart' in document.documentElement) {
            isTouchScreen = true;
        }
    })();

    if (toggleLanguage != null) {
        toggleLanguage.addEventListener('click', function () {
            this.parentElement.classList.toggle('open');
            body.classList.toggle('open-language');
        });
    };

    if (backdrop != null) {
        backdrop.addEventListener('click', function () {
            body.classList.remove('open-search');
            body.classList.remove('open-mainmenu');
        });
    };

    if (isTouchScreen) {
        document.addEventListener('touchend', function (event) {
            toggleNavLink(event);
            toggleMainMenu(event);
            toggleSearch(event);
        });
    } else {
        document.addEventListener('click', function (event) {
            toggleNavLink(event);
            toggleMainMenu(event);
            toggleSearch(event);
        });
    }

    function toggleNavLink(event) {
        if (!event.target.matches('.nav-link-toggle *')) return;
        event.preventDefault();
        event.target.parentElement.parentElement.classList.toggle('show');
    }

    function toggleMainMenu(event) {
        if (!event.target.matches('.c-mainmenutoggle__btn')) return;
        event.preventDefault();
        body.classList.toggle('open-mainmenu');
        body.classList.remove('open-search');
    }

    function toggleSearch(event) {
        if (!event.target.matches('.c-topsearch__btn')) return;
        event.preventDefault();
        body.classList.toggle('open-search');
        body.classList.remove('open-mainmenu');
        document.getElementById('s').focus();
    }

    const activeDropdown = document.querySelectorAll('.c-mainmenu .dropdown.active');

    if (activeDropdown.length > 0) {
        activeDropdown.forEach(function (element) {
            element.classList.add('show');
        });
    }
}
